/**
 * The Gate 0 agent, as the UI sees it.
 *
 * The agent is a real directory row (seeded by migration 003) so that the
 * clears and comments it writes carry a name in the ledger rather than
 * hiding behind the system user. That is right for the audit trail and wrong
 * for the surfaces where a *person* is expected: it turns up as a selectable
 * owner, a selectable team member, a selectable override approver, and as
 * the author of the duplicate-review comment.
 *
 * So it is filtered out of those, and left alone everywhere the record is
 * the point — the activity feed and the gate log still name it, because
 * "who advanced this" is not a cosmetic detail.
 *
 * Both handles must match `api/src/shared/auth/gateAgentPrincipal.ts`. The
 * UPN is the reliable one and is used wherever the wire carries it; comments
 * only carry a display name, so that is matched there. If either drifts the
 * agent reappears in a picker — visible and harmless, not a broken page.
 */

export const GATE_AGENT_UPN = 'orion-gate-agent@trelleborg.com'
export const GATE_AGENT_DISPLAY_NAME = 'Orion Gate Agent'

/** True for the agent's row in a user lookup. */
export function isGateAgentUser(user: { userPrincipalName: string; displayName: string }): boolean {
  return (
    user.userPrincipalName.toLowerCase() === GATE_AGENT_UPN ||
    user.displayName === GATE_AGENT_DISPLAY_NAME
  )
}

/** True for something the agent authored, matched on the only handle present. */
export function isGateAgentAuthor(displayName: string): boolean {
  return displayName === GATE_AGENT_DISPLAY_NAME
}
